import createReactComponent from '../createReactComponent';
export default createReactComponent('wash-dry-w', 'IconWashDryW', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M8 8l1.5 8h1l1.5 -6l1.5 6h1l1.5 -8', key: 'svg-1' }],
]);
